module.exports = __webpack_public_path__ + "static/media/missing_ru.acd69a82.jpg";